import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-super-skill-results-dashboard',
  templateUrl: './super-skill-results-dashboard.component.html',
  styleUrls: ['./super-skill-results-dashboard.component.scss']
})
export class SuperSkillResultsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
